import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { session } = UserAuth();
  console.log('[ProtectedRoute] Rendered. session:', !!session, 'URL:', window.location.href)

  // Still loading — show nothing briefly rather than flash redirect
  if (session === undefined) return null;

  // No session → redirect to landing
  if (!session) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;
